module.exports = __webpack_public_path__ + "static/m_solution4-bf763140dd2c7fd414dab4ad68773a2d.png";